export default __webpack_public_path__ + "atomic/_patterns/02-molecules/sales-managers-table/_sales-managers-table.twig";